import {createContext} from 'react';

export interface LayerCtx {
    visible: boolean
    activeFilters: any
    bikeLayerVisible: boolean
    toggleActive: (type: string, active: boolean) => void
    toggleVisible: (value?: any) => void,
    toggleVisibleBikeLayer: (value?: any) => void,
}

export const LayerContext = createContext<LayerCtx>(
    {
        visible: false,
        bikeLayerVisible: false,
        activeFilters: {},
        toggleActive: (type: string, active: boolean) => {
        },
        toggleVisible: () => {
        },
        toggleVisibleBikeLayer: () => {
        },
    });

export const LayerProvider = LayerContext.Provider;
